<template>
  <CRow>
    <CCol>
      <CCard class="p-3">
        <CCardHeader>
          <div class="countCard_Header d-flex justify-content-between content-center mb-4">
            <h5>{{ $t('settings.planAndBilling.nextPayment.header') }}</h5>
            <CButton @click="$router.push({ name: 'plan-invoices' })" class="px-4" variant="outline" color="primary">{{
              $t('settings.planAndBilling.nextPayment.button.allInvoices')
            }}</CButton>
          </div>
        </CCardHeader>
        <CCardBody class="">
          <div v-if="items.length > 0" class="currentPlan">
            <CRow>
              <CCol class="textAddons" sm="3">{{ paymentThisMonth.planName }} + {{ $t('planSubscription.overview.nextPayment.text.addons') }}</CCol>
              <CCol sm="2">
                <div class="subTextAddons">{{ $t('planSubscription.overview.nextPayment.text.nextPayment') }}</div>
                <div class="textAddons">{{ paymentThisMonth.nextPayment ? formatStringMed(paymentThisMonth.nextPayment) : '' }}</div></CCol
              >
              <CCol sm="2">
                <div class="subTextAddons">{{ $t('planSubscription.overview.nextPayment.text.totalCost') }}</div>
                <div class="textAddons">{{ paymentThisMonth.totalCost ? formatCurrency(paymentThisMonth.totalCost) : '' }}</div></CCol
              >
              <CCol class="text-right mt-2">
                <u style="cursor: pointer" class="text-capitalize" @click="expanded = !expanded">{{
                  !expanded ? $t('planSubscription.overview.nextPayment.text.expand') : $t('planSubscription.overview.nextPayment.text.Collapse')
                }}</u>
                <CIcon :class="expanded ? 'invert-icon' : ''" name="arrow" class="mx-1" size="custom-size" :height="15" viewBox="0 0 32 32" />
              </CCol>
            </CRow>
            <CCollapse class="mt-4" :show="expanded">
              <CDataTable :items="items" :fields="headers" border addTableClasses="headers-table table-border">
                <template #amount="{ item }">
                  <td class="text-right" :class="item.defaultColum ? 'bold-text' : ''">
                    {{ formatCurrency(item.amount) }}
                  </td>
                </template>
              </CDataTable>
              <CRow class="mt-1" alignHorizontal="end">
                <CCol sm="5" class="text-right text-bottom">
                  {{ $t('planSubscription.overview.nextPayment.text.ofTotalCost') }}
                </CCol>
              </CRow>
            </CCollapse>
          </div>
          <div v-else class="text-center my-4 canceled-text">{{ $t('planSubscription.overview.nextPayment.text.canceledText') }}</div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { currencyFormat } from '@/utils/numbersFormatUtil.js'
import { dateFormatStringMed } from '@/utils/dateUtil'

export default {
  name: 'OverViewNextPayment',
  props: {
    paymentThisMonth: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      expanded: false,
      items: [],
      headers: [
        { key: 'description', label: this.$t('planSubscription.overview.nextPayment.table.header.description') },
        {
          key: 'amount',
          _classes: 'text-right ',
          label: this.$t('planSubscription.overview.nextPayment.table.header.amount') + '(€)',
        },
      ],
    }
  },
  mounted() {
    this.processPayments()
  },
  methods: {
    formatStringMed(date) {
      return dateFormatStringMed(date)
    },

    formatCurrency(value) {
      return currencyFormat(value)
    },

    processPayments() {
      let list = this.paymentThisMonth.items
      if (Array.isArray(list)) {
        list.push({
          defaultColum: true,
          description: this.$t('planSubscription.overview.nextPayment.table.content.tax'),
          amount: this.paymentThisMonth.tax,
          _cellClasses: { description: 'text-right bold-text ' },
        })

        list.push({
          defaultColum: true,
          description: this.$t('planSubscription.overview.nextPayment.table.content.totalCost'),
          amount: this.paymentThisMonth.totalCost,
          _cellClasses: { description: 'text-right bold-text ' },
        })
        this.items = list
      }
    },
  },
}
</script>

<
<style lang="scss" scope>
.subTextPayment {
  color: #868e96;
  font-size: 12px;
}

.textPayment {
  font-size: 16px;
  color: #343a40;
  font-weight: bold;
}

.currentPlan {
  border-radius: 10px;
  border: 1px solid #dee2e6;
  padding: 20px;
}

.invert-icon {
  transform: rotate(180deg);
}

.headers-table thead {
  color: $gray-base;
  background-color: $gray-100;
}

.text-bottom {
  color: $gray-400;
}

.bold-text {
  font-weight: 800;
}

.canceled-text {
  color: $gray-400;
  font-size: $font-size-xs;
  font-weight: $font-weight-semi-bold;
  line-height: 1.4em;
}
</style>
